import React from 'react';
import moment from 'moment';
import { i18n } from '../../translate/i18n';
import {
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  Chip,
  Box,
} from '@mui/material';

import AddIcon from '@mui/icons-material/AddCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import statusLabel from '../../utils/statusLabel';

export default function ExpandPanels(props) {

  return (
    <Accordion
      style={{ borderRadius: 5 }}
      disabled={props.disabled}
      expanded={true}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div style={styles.expansionHeader}>
          <Typography style={{ width: '40%' }}>{i18n.t('typographyActionExpansion.action')}({props.data && props.data.length})</Typography>
          <IconButton style={{ padding: 0 }} onClick={props.onAdd} size="large">
            <Tooltip title={i18n.t('tooltipActionExpPanel.title')}>
              <AddIcon />
            </Tooltip>
          </IconButton>
        </div>
      </AccordionSummary>
      <AccordionDetails
        style={{ padding: 0 }}
      >
        <List
          style={{ width: '100%' }}
          component="nav">
          {props.data && props.data.map(dt =>

            <ListItem button key={dt._id} onClick={() => props.onEdit(dt)}>
              <ListItemText primary={
                <>
                  <Typography sx={[styles.actionLabel, { wordBreak: "break-word" }]}>
                    <b>{i18n.t('typographyActionExpansion.problem')}</b>
                    {dt.problemText || '-'}
                  </Typography>
                  <Typography sx={[styles.actionLabel, { wordBreak: "break-word" }]}>
                    <b>{i18n.t('typographyActionExpansion.action')}</b>
                    {dt.actionText}
                  </Typography>
                  <div style={styles.itemBottom}>
                    <Box sx={{ maxWidth: '85%'}}>
                      <Typography style={styles.actionLabel}>
                        <b>{i18n.t('typographyActionExpansion.accountable')}</b>
                        {dt.accountables?.length > 0 ? dt.accountables.map((accountable) => <Chip sx={{...styles.chip, color: "#000"}} label={accountable.name} />) : i18n.t('typographyActionExpansion.noAccountable')}
                      </Typography>
                      <Typography style={styles.actionLabel}><b>{i18n.t('typographyActionExpansion.deadline')}</b>{moment(dt.deadline).format('DD/MM/YYYY')}</Typography>
                    </Box>
                    <Chip label={statusLabel(dt.status, dt.deadline).title} style={{ ...styles.chip, backgroundColor: statusLabel(dt.status, dt.deadline).color }} />
                  </div>
                </>}
              />
            </ListItem>
          )}
        </List>

      </AccordionDetails>

    </Accordion>
  );
}


const styles = {
  actionContainer: {
    padding: 15,
    cursor: 'pointer',
  },
  actionLabel: {
    fontSize: 14,
    marginTop: '5px',
  },
  chip: {
    margin: '3px',
    color: '#fff',
  },
  itemBottom: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  expansionHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  }
}
